import { useContext } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserAlt } from "@fortawesome/free-solid-svg-icons";
import { AppContext } from "../../context";

const StyledLink = styled(Link)`
  text-decoration: none;
  color: #ee7d09;
`;

const StyledAccount = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledAccountInner = styled.section`
  display: flex;
  border: 1px solid #ee7d09;
  border-radius: 100px;
  padding: 5px;
  cursor: pointer;
  align-items: center;
  max-width: 200px;
  transition: border-color 0.5s ease;
  &:hover {
    border-color: #ee7d09;
    transition: border-color 0.5s ease;
    p {
      color: #ee7d09;
      transition: color 0.5s ease;
    }
    section:nth-child(1) {
      background-color: #ee7d09;
      transition: background-color 0.5s ease;
      svg {
        color: #ffffff;
        transition: color 0.5s ease;
      }
    }
  }
`;

const StyledAccountImage = styled.section`
  width: 25px;
  height: 25px;
  border-radius: 100%;
  background-color: #ee7d09;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.5s ease;
  img {
    width: 100%;
    height: auto;
  }
  svg {
    color: #ffffff;
    transition: color 0.5s ease;
  }
`;

const StyledAccountName = styled.section`
  display: flex;
  padding: 0px;
  align-items: center;
  p {
    font-size: 16px;
    font-weight: normal;
    color: #000000;
    margin: 0px;
    padding: 0px 20px 0px 10px;
    transition: color 0.5s ease;
  }
`;

const AccountSection = () => {
  const {
    isLoggedIn,
    userProfile: { fullName = "Sivasankar", photo = "" },
  } = useContext(AppContext);

  const shortName = fullName.split(" ")[0];

  return (
    <StyledAccount>
      {isLoggedIn ? (
        <StyledLink to="/profile" title="Profile">
          <StyledAccountInner>
            <StyledAccountImage>
              {photo ? (
                <img src={photo} alt={shortName} />
              ) : (
                <FontAwesomeIcon icon={faUserAlt} />
              )}
            </StyledAccountImage>
            <StyledAccountName>
              <p>{shortName}</p>
            </StyledAccountName>
          </StyledAccountInner>
        </StyledLink>
      ) : (
        <StyledLink to="/login" title="Login">
          <StyledAccountInner>
            <StyledAccountImage>
              <FontAwesomeIcon icon={faUserAlt} />
            </StyledAccountImage>
            <StyledAccountName>
              <p>Login</p>
            </StyledAccountName>
          </StyledAccountInner>{" "}
        </StyledLink>
      )}
    </StyledAccount>
  );
};

export default AccountSection;
